import {
	ContainerIconSubtitle,
	DataContainer,
	HeaderTitle,
	SubTitle,
	Title,
	Wrapper,
} from './styles';
export type Item = {
	title: string;
	value?: string;
	leftIcon?: JSX.Element | null;
	link?: string;
};

interface DetailProps {
	title?: string;
	items: Item[];
	backgroundColor?: string;
	fontSize?: string;
	width?: string;
	height?: string;
}

const Detail = ({ title, items, backgroundColor, fontSize, width, height }: DetailProps) => {
	const moreThanOneItem: boolean = items.length > 1;

	return (
		<Wrapper width={width} heigth={height}>
			{title && (
				<HeaderTitle>
					<Title>{title}</Title>
				</HeaderTitle>
			)}
			{items.map(({ title, value, leftIcon }, index) => (
				<DataContainer
					key={index}
					moreThanOneItem={moreThanOneItem}
					lengthItems={items.length}
					currentPosition={index}
					backgroundColor={backgroundColor}
				>
					<SubTitle fontSize={fontSize}>{title}</SubTitle>
					{leftIcon ? (
						<ContainerIconSubtitle>
							{leftIcon}
							<SubTitle textAlign="end" fontSize={fontSize}>
								{value}
							</SubTitle>
						</ContainerIconSubtitle>
					) : (
						<SubTitle textAlign="end" fontSize={fontSize}>
							{value}
						</SubTitle>
					)}
				</DataContainer>
			))}
		</Wrapper>
	);
};

export { Detail };
